<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="On-Sale" subTitle="Sale Details"></app-breadcrumb>

        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mb-n2">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- count -->
        <div class="row">
            <div class="col-12">
                <p><span class="h3 md-small-text">Sales Rule Details</span> <br>(see details on this sales rule performance)</p>
            </div>
        </div>
        
        <!-- view a selected promotion -->
        <div class="row" v-if="theRuleResults">
            <div class="col-sm-6 col-12">
                <div class="jumbotron bg-light p-4 h-100">
                    <dl class="row">
                        <dt class="col-sm-3">Rule Name:</dt>
                        <dd class="col-sm-9 font-weight-bold"><p>{{theRuleResults.name | capitalize}}</p></dd>
                        
                        <dt class="col-sm-3">Discount:</dt>
                        <dd class="col-sm-9 text-danger">
                            <p>{{theRuleResults.percentage}}% off original price</p>
                        </dd>
                        
                        <dt class="col-sm-3">Description:</dt>
                        <dd class="col-sm-9"><p>{{theRuleResults.description | capitalize}}</p></dd>

                        <template v-if="theRuleResults.starts">
                            <dt class="col-sm-3">Starts:</dt>
                            <dd class="col-sm-9">
                                <p class="text-dark-green">{{theRuleResults.starts | moment("MMM D YYYY hh:mm A")}}</p>
                            </dd>
                        </template>
                        
                        <template v-if="theRuleResults.stops">
                            <dt class="col-sm-3">Stops:</dt>
                            <dd class="col-sm-9">
                                <p class="text-danger">{{theRuleResults.stops | moment("MMM D YYYY hh:mm A")}}</p>
                            </dd>
                        </template>

                        <dt class="col-sm-3">Affected:</dt>
                        <dd class="col-sm-9"><p>{{theRuleResults.itemIds.length}} Items</p></dd>

                        <dt class="col-sm-3">Currently:</dt>
                        <dd class="col-sm-9">
                            <p v-if="theRuleResults.applied" class="text-dark-green">Active</p>
                            <p v-else class="text-danger">Inactive</p>
                        </dd>

                        <template v-if="theRuleResults.appliedTime">
                            <dt class="col-sm-3">Applied:</dt>
                            <dd class="col-sm-9">
                                <p>{{theRuleResults.appliedTime | moment("MMM D YYYY hh:mm A")}}</p>
                            </dd>
                        </template>

                        <dt class="col-sm-3">Created:</dt>
                        <dd class="col-sm-9">
                            <p>{{theRuleResults.joined | moment("MMM D YYYY hh:mm A")}}</p>
                        </dd>
                    </dl>
                    <hr>
                    <router-link :to="{ name: 'on-sale'}" tag="a" class="btn btn-light bg-silver mr-2"> &lt;&lt; Go Back</router-link>
                    <button @click="endSalesRuleFxn" v-if="theRuleResults.applied" class="loadn btn btn-danger">
                        <i class="fas fa-times"></i> End Sale <span class="hide-on-mobile">Now</span>
                    </button>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="h-100">
                    <!-- affected categories -->
                    <div class="card mb-3" v-if="theRuleResults.categories.length">
                        <div class="card-header">
                            Affected Categories ({{theRuleResults.categories.length}})
                        </div>
                        <div class="card-body pre-scrollable p-0">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" v-for="(category, i) in theRuleResults.categories" :key="i">{{i+1}}. 
                                    <router-link :to="{ name: 'user-category', params: { handle: user.userHandle, category } }">
                                        {{category | capitalize}}
                                    </router-link>
                                    <template v-if="theRuleResults.categories.length > 1">
                                        <i @click="removeCategory(category)" class="fas fa-times text-danger ml-3 clickable"></i>
                                    </template>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- affected items -->
                    <div class="card" v-if="theRuleResults.items.length">
                        <div class="card-header">
                            Affected Items ({{theRuleResults.items.length}})
                        </div>
                        <div class="card-body pre-scrollable p-0">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" v-for="(item, i) in theRuleResults.items" :key="i">{{i+1}}. 
                                    <router-link :to="{ name: 'itemId', params: { id: item.id } }">{{item.title | capitalize}} - ({{item.category}})</router-link>
                                    <template v-if="theRuleResults.items.length > 1">
                                        <i @click="removeItem(item.id)" class="fas fa-times text-danger ml-3 clickable"></i>
                                    </template>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Breadcrumb from '../../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "SaleDetails",
    data() {
        return {
            msg: '',
            color: 'danger',
            removeItemsArr: [],
            removeCategoryName: ''
        }
    },
    methods: {
        ...mapActions(['fetchRuleResults', 'endSalesRule', 'removeSaleItem']),
        updatePage(newRuleId){
            let ruleObj = {
                ruleId: newRuleId,
                userId: this.user._id,
            }
            this.fetchRuleResults(ruleObj).then(() => {}).catch((e) => {})
        },
        endSalesRuleFxn() {
            this.resetMsg()
            let ruleObj = {
                userId: this.user._id,
                ruleId: this.theRuleResults._id
            }
            // vuejs-dialog usage for pop up confirmations
            // https://github.com/Godofbrowser/vuejs-dialog
            let message = "<center>This will immediately remove the discounts on all the affected items! Do you want to proceed ?</center>";
            let options = {
                html: true, 
                okText: 'Yes, Proceed',
                cancelText: 'Cancel',
                animation: 'bounce', // Available: "zoom", "bounce", "fade"
            }
            this.$dialog.confirm(message, options)
            .then((dialog) => {
                // proceed with end sales rule action here
                this.endSalesRule(ruleObj)
                .then((data) => {
                    if(!data.error){
                        this.$router.push({
                            name: 'on-sale'
                        }).catch((e) => {})
                    }
                    this.msg = data.msg
                })
                .catch((e) => {})
            })
            .catch((e) => {})
        },
        removeCategory(categoryName) {
            this.resetMsg()
            this.removeItemsArr = []
            this.removeCategoryName = categoryName

            if(this.theRuleResults){
                // extract the category items first then proceed to removal
                let categoryItems = this.theRuleResults.items.filter(item => item.category == categoryName)
                for(let y=0; y < categoryItems.length; y++){
                    this.removeItemsArr.push(categoryItems[y].id)
                }
                // vuejs-dialog usage for pop up confirmations
                let message = "<center>This will remove all items under this category from this sales rule! Do you want to proceed ?</center>";
                let options = {
                    html: true, 
                    okText: 'Yes, Proceed',
                    cancelText: 'Cancel',
                    animation: 'bounce', // Available: "zoom", "bounce", "fade"
                }
                this.$dialog.confirm(message, options)
                .then((dialog) => {
                    // proceed with removal here
                    this.removeSaleItemFxn()
                })
                .catch((e) => {})
            }
        },
        removeItem(itemId) {
            this.resetMsg()
            this.removeItemsArr = []
            this.removeItemsArr.push(itemId)

            // vuejs-dialog usage for pop up confirmations
            let message = "<center>This will remove this item from this sales rule! Do you want to proceed ?</center>";
            let options = {
                html: true, 
                okText: 'Yes, Proceed',
                cancelText: 'Cancel',
                animation: 'bounce', // Available: "zoom", "bounce", "fade"
            }
            this.$dialog.confirm(message, options)
            .then((dialog) => {
                // proceed with removal here
                this.removeSaleItemFxn()
            })
            .catch((e) => {})
        },
        removeSaleItemFxn() {
            this.resetMsg()
            let ruleObj = {
                userId: this.user._id,
                ruleId: this.theRuleResults._id,
                itemIds: this.removeItemsArr,
                category: this.removeCategoryName
            }
            this.removeSaleItem(ruleObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success"
                    this.removeItemsArr = []
                    this.removeCategoryName = ''
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        },
        resetMsg() {
            this.msg = ''
            this.color = "danger"
        }
    },
    computed: {
        ...mapGetters(['user', 'ruleResults']),
        theRuleResults() {
            if(this.ruleResults && this.ruleResults !== null){
                return this.ruleResults
            }
            return false
        }
    },
    watch: {
        $route() {
            this.updatePage(this.$route.params.id)
        }
    },
    components: {
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.updatePage(this.$route.params.id)
        this.$emit('update:layout', LayoutShop);
    }
}
</script>